import { gql } from "@apollo/client";
import { DEDUCTION_FRAGMENT } from "./deductionFragment";

const GET_APPROVALS_BY_REMITTANCE = gql`
  ${DEDUCTION_FRAGMENT}
  query GetApprovalsByRemittance($params: GetApprovalsParams!) {
    getApprovalsByRemittance(params: $params) {
      total
      page
      limit
      columns {
        key
        title
      }
      items {
        remittanceId
        checkNo
        checkDate
        deductedAmount
        pendingCount
        purchaser {
          purchaserId
          purchaserName
          purchaserKey
        }
        deductions {
          ...DeductionFields
        }
      }
    }
  }
`;

export default GET_APPROVALS_BY_REMITTANCE;
